import validate from "/usr/src/nuxt-app/node_modules/nuxt/dist/pages/runtime/validate.js";
import redirect_45global from "/usr/src/nuxt-app/middleware/redirect.global.ts";
import auth0 from "/usr/src/nuxt-app/node_modules/@auth0/auth0-nuxt/dist/runtime/middleware/auth.server.js";
import manifest_45route_45rule from "/usr/src/nuxt-app/node_modules/nuxt/dist/app/middleware/route-rules.js";
export const globalMiddleware = [
  validate,
  redirect_45global,
  auth0,
  manifest_45route_45rule
]
export const namedMiddleware = {}